document.documentElement.classList.remove('no-js')

document.addEventListener('scroll', () => {
  const header = document.querySelector('[data-site-header]')
  if (!header) return
  header.classList.toggle('is-scrolled', window.scrollY > 10)
}, { passive: true })

document.addEventListener('click', (event) => {
  const announcementClose = event.target.closest('[data-announcement-close]')
  if (announcementClose) {
    const bar = announcementClose.closest('[data-announcement-bar]')
    if (bar) {
      bar.style.display = 'none'
    }
    return
  }

  const button = event.target.closest('[data-carousel-scroll]')
  if (!button) return

  const targetId = button.getAttribute('data-carousel-target')
  const direction = button.getAttribute('data-carousel-scroll')
  if (!targetId || !direction) return

  const track = document.getElementById(targetId)
  if (!track) return

  const firstCard = track.querySelector('[data-carousel-item]')
  const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 300
  const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0') || 0
  const delta = (cardWidth + gap) * 2
  track.scrollBy({
    left: direction === 'left' ? -delta : delta,
    behavior: 'smooth'
  })
})

const syncHeaderActiveLinks = () => {
  const links = Array.from(document.querySelectorAll('.header-nav a, .mobile-drawer a'))
  if (!links.length) return

  const current = new URL(window.location.href)
  const currentPath = current.pathname
  const currentPathAndSearch = `${current.pathname}${current.search}`

  links.forEach((link) => {
    link.classList.remove('is-active')
    link.removeAttribute('aria-current')
  })

  const scoredMatches = links
    .map((link) => {
      const linkUrl = new URL(link.href, window.location.origin)
      if (`${linkUrl.pathname}${linkUrl.search}` === currentPathAndSearch) {
        return { link, score: 100 }
      }
      if (linkUrl.pathname !== currentPath) {
        return { link, score: 0 }
      }

      const linkParams = new URLSearchParams(linkUrl.search)
      if (!linkParams.toString()) {
        return { link, score: 1 }
      }

      let matchedParams = 0
      for (const [key, value] of linkParams.entries()) {
        if (current.searchParams.get(key) !== value) {
          return { link, score: 0 }
        }
        matchedParams += 1
      }

      return { link, score: 10 + matchedParams }
    })
    .filter((item) => item.score > 0)

  const maxScore = scoredMatches.reduce((max, item) => Math.max(max, item.score), 0)
  let activeLinks = scoredMatches.filter((item) => item.score === maxScore).map((item) => item.link)
  if (maxScore === 1 && activeLinks.length > 1) {
    activeLinks = []
  }

  activeLinks.forEach((link) => {
    link.classList.add('is-active')
    link.setAttribute('aria-current', 'page')
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncHeaderActiveLinks)
} else {
  syncHeaderActiveLinks()
}
window.addEventListener('load', syncHeaderActiveLinks)
setTimeout(syncHeaderActiveLinks, 0)

;(() => {
  const drawer = document.querySelector('[data-style-finder-drawer]')
  if (!drawer) return

  const trigger = document.querySelector('[data-style-finder-open]')
  const backdrop = document.querySelector('[data-style-finder-backdrop]')
  const closeButtons = drawer.querySelectorAll('[data-style-finder-close]')
  const resetButton = drawer.querySelector('[data-style-finder-reset]')
  const form = drawer.querySelector('[data-style-finder-form]')
  const results = drawer.querySelector('[data-style-finder-results]')
  const resultsList = drawer.querySelector('[data-style-finder-results-list]')
  const notesInput = drawer.querySelector('#StyleFinderNotes')
  const productNodes = Array.from(drawer.querySelectorAll('[data-product]'))
  const chipGroups = Array.from(drawer.querySelectorAll('[data-style-finder-group]'))
  const cartAddUrl = drawer.getAttribute('data-cart-add-url') || '/cart/add.js'
  const cartUrl = drawer.getAttribute('data-cart-url') || '/cart'

  const resultsHeading = results ? results.querySelector('h3') : null

  const products = productNodes.map((node) => ({
    title: node.dataset.title || '',
    url: node.dataset.url || '#',
    price: node.dataset.price || '',
    priceCents: parseInt(node.dataset.priceCents || '0', 10) || 0,
    variantId: parseInt(node.dataset.variantId || '0', 10) || 0,
    available: node.dataset.available === 'true',
    type: (node.dataset.type || '').toLowerCase(),
    tags: (node.dataset.tags || '').toLowerCase(),
    image: node.dataset.image || '',
    imageAlt: node.dataset.imageAlt || ''
  }))

  const state = { region: 'usa', notes: '' }

  const keywordMap = {
    occasion: {
      wedding: ['wedding', 'bridal', 'neckset', 'kundan', 'set'],
      engagement: ['engagement', 'bridal', 'statement', 'set'],
      festival: ['festival', 'temple', 'traditional', 'gold'],
      party: ['party', 'cocktail', 'statement', 'earring', 'choker'],
      everyday: ['everyday', 'daily', 'minimal', 'lightweight']
    },
    'outfit-color': {
      green: ['green', 'emerald', 'mint'],
      red: ['red', 'ruby', 'maroon'],
      ivory: ['ivory', 'pearl', 'white', 'diamond'],
      gold: ['gold', 'kundan', 'temple'],
      black: ['black', 'oxidized', 'onyx']
    },
    'jewelry-weight': {
      lightweight: ['lightweight', 'minimal', 'daily', 'stud', 'drop'],
      medium: ['medium', 'classic', 'layered'],
      statement: ['statement', 'bridal', 'grand', 'choker', 'haram', 'neckset']
    }
  }

  const seedDefaultSelections = () => {
    chipGroups.forEach((group) => {
      const groupName = group.getAttribute('data-style-finder-group')
      if (!groupName) return
      const selected = group.querySelector('.style-finder-chip.is-selected')
      if (selected) {
        state[groupName] = selected.getAttribute('data-value') || ''
      }
    })
  }

  const escapeHtml = (value) =>
    value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;')

  const openDrawer = () => {
    drawer.classList.add('is-open')
    drawer.setAttribute('aria-hidden', 'false')
    trigger?.setAttribute('aria-expanded', 'true')
    if (backdrop) backdrop.hidden = false
    requestAnimationFrame(() => drawer.focus())
  }

  const closeDrawer = () => {
    drawer.classList.remove('is-open')
    drawer.setAttribute('aria-hidden', 'true')
    trigger?.setAttribute('aria-expanded', 'false')
    if (backdrop) backdrop.hidden = true
  }

  const clearForm = () => {
    Object.keys(state).forEach((key) => delete state[key])
    state.region = 'usa'
    state.notes = ''
    chipGroups.forEach((group) => {
      group.querySelectorAll('.style-finder-chip.is-selected').forEach((chip) => chip.classList.remove('is-selected'))
    })
    const usaChip = drawer.querySelector('[data-style-finder-group=\"region\"] .style-finder-chip[data-value=\"usa\"]')
    if (usaChip) usaChip.classList.add('is-selected')
    if (notesInput) notesInput.value = ''
    seedDefaultSelections()
    results.hidden = true
    form.hidden = false
  }

  // Budget tiers are derived from the store's REAL product prices so a range
  // can never be empty. Rebuilt from the products actually rendered in the drawer.
  let budgetTiers = []

  const buildBudgetTiers = () => {
    const cents = products.map((p) => p.priceCents).filter((c) => c > 0).sort((a, b) => a - b)
    if (!cents.length) return []
    const n = cents.length
    const min = cents[0]
    const max = cents[n - 1]
    if (min === max) return []
    const up = (c) => '$' + Math.ceil(c / 100)
    const down = (c) => '$' + Math.floor(c / 100)
    const cut1 = cents[Math.floor(n / 3)]
    const cut2 = cents[Math.floor((2 * n) / 3)]
    let tiers = [
      { value: 'b1', min: 0, max: cut1, label: 'Under ' + up(cut1 + 1) },
      { value: 'b2', min: cut1 + 1, max: cut2, label: up(cut1 + 1) + '–' + down(cut2) },
      { value: 'b3', min: cut2 + 1, max: Infinity, label: down(cut2 + 1) + ' & up' }
    ]
    // keep only tiers that actually contain products, and drop duplicate ranges
    const seen = {}
    tiers = tiers.filter((t) => {
      const hasProducts = products.some((p) => p.priceCents > 0 && p.priceCents >= t.min && p.priceCents <= t.max)
      if (!hasProducts) return false
      const key = t.min + '-' + t.max
      if (seen[key]) return false
      seen[key] = true
      return true
    })
    return tiers
  }

  const renderBudgetChips = () => {
    const group = drawer.querySelector('[data-style-finder-group="budget"]')
    if (!group) return
    const chipWrap = group.querySelector('.style-finder-chips')
    if (!chipWrap) return
    budgetTiers = buildBudgetTiers()
    if (budgetTiers.length < 2) {
      // A single (or no) price band is not a useful filter — hide the question.
      group.hidden = true
      chipWrap.innerHTML = ''
      return
    }
    group.hidden = false
    chipWrap.innerHTML = budgetTiers
      .map((t) => `<button type="button" class="style-finder-chip" data-value="${t.value}">${escapeHtml(t.label)}</button>`)
      .join('')
  }

  const budgetPredicate = (budget) => {
    if (!budget) return () => true
    const tier = budgetTiers.find((t) => t.value === budget)
    if (!tier) return () => true
    return (product) => product.priceCents > 0 && product.priceCents >= tier.min && product.priceCents <= tier.max
  }

  const rankProducts = () => {
    const selectedTextTokens = []
    const selectedKeywordTokens = []

    Object.entries(state).forEach(([group, value]) => {
      if (!value || group === 'budget' || group === 'region' || group === 'notes') return
      selectedTextTokens.push(String(value).toLowerCase())
      const mapped = keywordMap[group]?.[value]
      if (mapped?.length) selectedKeywordTokens.push(...mapped)
    })

    const noteTokens = (state.notes || '')
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter((token) => token.length > 2)
      .slice(0, 8)

    // Budget is a hard filter on real prices; ranges are derived from the catalog
    // so a chosen budget always yields at least one product.
    const matchBudget = budgetPredicate(state.budget)
    const budgetMatched = products.filter((p) => p.available && matchBudget(p))
    const availableAll = products.filter((p) => p.available)
    const source = budgetMatched.length ? budgetMatched : (availableAll.length ? availableAll : products)

    const scored = source
      .map((product) => {
        const haystack = `${product.title} ${product.type} ${product.tags}`.toLowerCase()
        let score = 0
        selectedTextTokens.forEach((value) => {
          if (haystack.includes(value)) score += 3
        })
        selectedKeywordTokens.forEach((value) => {
          if (haystack.includes(value)) score += 2
        })
        noteTokens.forEach((value) => {
          if (haystack.includes(value)) score += 1
        })
        return { ...product, score }
      })
      .sort((a, b) => b.score - a.score || a.priceCents - b.priceCents)

    const topScore = scored.length ? scored[0].score : 0
    return { picks: scored.slice(0, 3), exact: topScore > 0 }
  }

  const renderRecommendations = () => {
    if (!products.length) {
      if (resultsHeading) resultsHeading.textContent = 'Recommendations'
      resultsList.innerHTML = '<div class=\"style-finder-empty\">Our collection is being updated — please check back shortly.</div>'
      return
    }

    const ranked = rankProducts()
    const picks = ranked.picks
    if (!picks.length) {
      if (resultsHeading) resultsHeading.textContent = 'Recommendations'
      resultsList.innerHTML = '<div class=\"style-finder-empty\">No pieces match those filters right now. Try a different budget or style.</div>'
      return
    }

    if (resultsHeading) {
      resultsHeading.textContent = ranked.exact ? 'Handpicked for you' : 'No exact match — here are close picks'
    }

    resultsList.innerHTML = picks
      .map((product) => {
        const imageMarkup = product.image
          ? `<img src=\"${escapeHtml(product.image)}\" alt=\"${escapeHtml(product.imageAlt || product.title)}\" loading=\"lazy\">`
          : ''

        return `
          <article class=\"style-finder-result-card\">
            <div class=\"style-finder-result-image\">${imageMarkup}</div>
            <div>
              <h4 class=\"style-finder-result-title\">${escapeHtml(product.title)}</h4>
              <span class=\"style-finder-result-price\">${escapeHtml(product.price)}</span>
              <div class=\"style-finder-result-actions\">
                <button
                  type=\"button\"
                  class=\"style-finder-result-add\"
                  data-style-finder-add
                  data-variant-id=\"${product.variantId}\"
                  ${product.available && product.variantId ? '' : 'disabled'}
                >${product.available && product.variantId ? 'Add to cart' : 'Unavailable'}</button>
                <a class=\"style-finder-result-link\" href=\"${escapeHtml(product.url)}\">View Product</a>
              </div>
            </div>
          </article>
        `
      })
      .join('')
  }

  trigger?.addEventListener('click', openDrawer)
  backdrop?.addEventListener('click', closeDrawer)
  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer))
  resetButton?.addEventListener('click', clearForm)

  notesInput?.addEventListener('input', () => {
    state.notes = notesInput.value.trim()
  })

  chipGroups.forEach((group) => {
    const groupName = group.getAttribute('data-style-finder-group')
    if (!groupName) return
    group.addEventListener('click', (event) => {
      const chip = event.target.closest('.style-finder-chip')
      if (!chip) return

      const wasSelected = chip.classList.contains('is-selected')
      group.querySelectorAll('.style-finder-chip').forEach((node) => node.classList.remove('is-selected'))

      if (wasSelected) {
        delete state[groupName]
        return
      }

      chip.classList.add('is-selected')
      state[groupName] = chip.getAttribute('data-value') || ''
    })
  })

  form?.addEventListener('submit', (event) => {
    event.preventDefault()
    if (state.region && state.region !== 'usa') {
      resultsList.innerHTML = '<div class=\"style-finder-empty\">Style Finder recommendations are currently available for USA only.</div>'
      form.hidden = true
      results.hidden = false
      return
    }
    renderRecommendations()
    form.hidden = true
    results.hidden = false
  })

  resultsList?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-style-finder-add]')
    if (!button || button.disabled) return

    const variantId = parseInt(button.getAttribute('data-variant-id') || '0', 10)
    if (!variantId) return

    button.disabled = true
    button.textContent = 'Adding...'
    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      if (!response.ok) throw new Error('Failed')

      button.textContent = 'Added'
      if (window.vkCartDrawer && typeof window.vkCartDrawer.open === 'function') {
        if (typeof window.vkCartDrawer.refresh === 'function') window.vkCartDrawer.refresh()
        closeDrawer()
        window.vkCartDrawer.open()
      } else {
        let cartCount = document.querySelector('.header-cart-count')
        if (!cartCount) {
          const cartLink = document.querySelector('.header-icon-link[href*="/cart"]')
          if (cartLink) {
            cartCount = document.createElement('span')
            cartCount.className = 'header-cart-count'
            cartCount.textContent = '1'
            cartLink.appendChild(cartCount)
          }
        } else {
          const current = parseInt(cartCount.textContent || '0', 10) || 0
          cartCount.textContent = String(current + 1)
        }
      }
    } catch (error) {
      button.disabled = false
      button.textContent = 'View Cart'
      button.addEventListener(
        'click',
        () => {
          window.location.href = cartUrl
        },
        { once: true }
      )
    }
  })

  seedDefaultSelections()
  renderBudgetChips()

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer()
    }
  })
})()

;(() => {
  const popup = document.querySelector('[data-launch-popup]')
  if (!popup) return

  const showForLoggedIn = popup.dataset.showForLoggedIn === 'true'
  const customerLoggedIn = popup.dataset.customerLoggedIn === 'true'
  if (!showForLoggedIn && customerLoggedIn) return

  const overlayCloseNodes = popup.querySelectorAll('[data-launch-popup-close]')
  const copyBtn = popup.querySelector('[data-launch-popup-copy]')
  const codeNode = popup.querySelector('[data-launch-popup-code]')
  const tab = document.querySelector('[data-launch-popup-reopen]')

  const hideDays = Number.parseInt(popup.dataset.hideDays || '7', 10)
  const delayMs = Number.parseInt(popup.dataset.delayMs || '800', 10)
  const storageKey = popup.dataset.storageKey || 'vk_launch_popup_global'

  const showTab = () => { if (tab) tab.hidden = false }
  const hideTab = () => { if (tab) tab.hidden = true }

  const closePopup = () => {
    popup.hidden = true
    document.body.classList.remove('vk-modal-open')
    try {
      const hideUntil = Date.now() + Math.max(hideDays, 1) * 24 * 60 * 60 * 1000
      window.localStorage.setItem(storageKey, String(hideUntil))
    } catch (error) {
      /* storage unavailable */
    }
    showTab() // collapse into the floating tab instead of disappearing forever
  }

  const openPopup = () => {
    popup.hidden = false
    document.body.classList.add('vk-modal-open')
    hideTab()
  }

  overlayCloseNodes.forEach((node) => {
    node.addEventListener('click', closePopup)
  })

  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup()
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup()
  })

  if (tab) tab.addEventListener('click', openPopup)

  if (copyBtn && codeNode) {
    copyBtn.addEventListener('click', async () => {
      const text = (codeNode.textContent || '').trim()
      if (!text) return
      try {
        await navigator.clipboard.writeText(text)
        copyBtn.textContent = 'Copied'
        window.setTimeout(() => {
          copyBtn.textContent = 'Copy'
        }, 1800)
      } catch (error) {
        copyBtn.textContent = 'Use code shown'
      }
    })
  }

  // Initial state: if recently dismissed, show the reopen tab instead of the popup;
  // otherwise auto-open after the configured delay.
  let hiddenUntil = 0
  try {
    hiddenUntil = Number.parseInt(window.localStorage.getItem(storageKey) || '0', 10)
  } catch (error) {
    hiddenUntil = 0
  }
  if (!Number.isNaN(hiddenUntil) && hiddenUntil > Date.now()) {
    showTab()
  } else {
    window.setTimeout(openPopup, Math.max(delayMs, 0))
  }
})()

;(() => {
  const policyRte = document.querySelector('.shopify-policy__body .rte')
  if (!policyRte) return
  if (policyRte.dataset.vkPolicyFormatted === 'true') return

  const source = (policyRte.innerText || '').replace(/\u00a0/g, ' ').replace(/\r/g, '').trim()
  if (!source) return
  if (!/(^|\n)\s{0,3}["']?(#{1,3}\s+.+|[-•]+\s+.+|---+)["']?\s*($|\n)/m.test(source)) return

  const escapeHtml = (value) =>
    value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;')

  const lines = source.split('\n')
  const htmlParts = []
  let inList = false

  const closeList = () => {
    if (!inList) return
    htmlParts.push('</ul>')
    inList = false
  }

  lines.forEach((rawLine) => {
    const line = rawLine.trim()
    if (!line) {
      closeList()
      return
    }

    const normalizedLine = line.replace(/^["'“”](.*)["'“”]$/, '$1').trim()
    const cleanLine = normalizedLine.replace(/^["'“”]+\s*/, '').replace(/\s*["'“”]+$/, '').trim()
    if (/^---+$/.test(cleanLine)) {
      closeList()
      htmlParts.push('<hr>')
      return
    }

    const h3Match = cleanLine.match(/^###\s+(.+)/)
    if (h3Match) {
      closeList()
      htmlParts.push(`<h3>${escapeHtml(h3Match[1])}</h3>`)
      return
    }

    const h2Match = cleanLine.match(/^##\s+(.+)/)
    if (h2Match) {
      closeList()
      htmlParts.push(`<h2>${escapeHtml(h2Match[1])}</h2>`)
      return
    }

    const h1LikeMatch = cleanLine.match(/^#\s+(.+)/)
    if (h1LikeMatch) {
      closeList()
      htmlParts.push(`<h2>${escapeHtml(h1LikeMatch[1])}</h2>`)
      return
    }

    const bulletMatch = cleanLine.match(/^[-•]+\s+(.+)/)
    if (bulletMatch) {
      if (!inList) {
        htmlParts.push('<ul>')
        inList = true
      }
      htmlParts.push(`<li>${escapeHtml(bulletMatch[1])}</li>`)
      return
    }

    closeList()
    const extraClass = /^Last updated:/i.test(cleanLine) ? ' class="vk-policy-updated"' : ''
    htmlParts.push(`<p${extraClass}>${escapeHtml(cleanLine)}</p>`)
  })

  closeList()
  if (!htmlParts.length) return

  policyRte.innerHTML = htmlParts.join('')
  policyRte.dataset.vkPolicyFormatted = 'true'
})()

/* ---------------- Cart drawer + AJAX add-to-cart ---------------- */
;(() => {
  const drawer = document.querySelector('[data-cart-drawer]')
  if (!drawer) return

  const panel = drawer.querySelector('.cart-drawer__panel')
  const body = drawer.querySelector('[data-cart-drawer-body]')
  const foot = drawer.querySelector('[data-cart-drawer-foot]')
  const subtotalNode = drawer.querySelector('[data-cart-drawer-subtotal]')
  const emptyNode = drawer.querySelector('[data-cart-drawer-empty]')
  const addedNote = drawer.querySelector('[data-cart-drawer-added]')
  const termsCheckbox = drawer.querySelector('[data-cart-drawer-terms]')
  const termsAlert = drawer.querySelector('[data-cart-drawer-terms-alert]')
  const checkoutBtn = drawer.querySelector('[data-cart-drawer-checkout]')

  const currency = drawer.getAttribute('data-currency') || 'USD'
  const cartUrl = drawer.getAttribute('data-cart-url') || '/cart'
  const changeUrl = drawer.getAttribute('data-cart-change-url') || '/cart/change.js'
  const updateUrl = drawer.getAttribute('data-cart-update-url') || '/cart/update.js'

  let lastFocused = null
  let addedTimer = null

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((cents || 0) / 100)
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2)
    }
  }

  const escapeHtml = (value) =>
    String(value == null ? '' : value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;')

  const updateHeaderCount = (count) => {
    const cartLink = document.querySelector('.header-icon-link[href*="/cart"]')
    if (!cartLink) return
    let badge = cartLink.querySelector('.header-cart-count')
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span')
        badge.className = 'header-cart-count'
        cartLink.appendChild(badge)
      }
      badge.textContent = String(count)
    } else if (badge) {
      badge.remove()
    }
  }

  const renderItem = (item, index) => {
    const options = (item.options_with_values || [])
      .filter((o) => o && o.value && o.value !== 'Default Title')
      .map((o) => `<span>${escapeHtml(o.name)}: ${escapeHtml(o.value)}</span>`)
      .join('')
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title || item.title)}" loading="lazy">`
      : ''
    return `
      <div class="cart-drawer-item" data-key="${escapeHtml(item.key)}" data-line="${index + 1}">
        <a class="cart-drawer-item__image" href="${escapeHtml(item.url)}">${image}</a>
        <div class="cart-drawer-item__meta">
          <a class="cart-drawer-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title || item.title)}</a>
          ${options ? `<div class="cart-drawer-item__options">${options}</div>` : ''}
          <div class="cart-drawer-item__row">
            <div class="cart-drawer-qty">
              <button type="button" data-cart-qty-dec aria-label="Decrease quantity">&minus;</button>
              <span class="cart-drawer-qty__value" data-cart-qty-value>${item.quantity}</span>
              <button type="button" data-cart-qty-inc aria-label="Increase quantity">+</button>
            </div>
            <span class="cart-drawer-item__price">${money(item.final_line_price)}</span>
          </div>
          <button type="button" class="cart-drawer-item__remove" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title || item.title)}">Remove</button>
        </div>
      </div>`
  }

  const render = (cart) => {
    if (!cart) return
    updateHeaderCount(cart.item_count)
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>'
      if (foot) foot.hidden = true
      return
    }
    body.innerHTML = cart.items.map(renderItem).join('')
    if (subtotalNode) subtotalNode.textContent = money(cart.items_subtotal_price)
    const discountsNode = drawer.querySelector('[data-cart-drawer-discounts]')
    const noteNode = drawer.querySelector('.cart-drawer__note')
    const discountApps = cart.cart_level_discount_applications || []
    if (discountsNode) {
      if (discountApps.length) {
        let dhtml = ''
        discountApps.forEach((d) => {
          dhtml += '<div style="display:flex;justify-content:space-between;margin-top:0.8rem;color:var(--vk-gold-text,#6f5327);"><span>' + escapeHtml(d.title) + '</span><strong>&minus;' + money(d.total_allocated_amount) + '</strong></div>'
        })
        dhtml += '<div style="display:flex;justify-content:space-between;margin-top:0.8rem;padding-top:0.8rem;border-top:1px solid var(--vk-border,#e7dfd6);"><span>Estimated total</span><strong>' + money(cart.total_price) + '</strong></div>'
        discountsNode.innerHTML = dhtml
        discountsNode.hidden = false
      } else {
        discountsNode.innerHTML = ''
        discountsNode.hidden = true
      }
    }
    if (noteNode) noteNode.textContent = discountApps.length ? 'Shipping calculated at checkout.' : 'Shipping and discounts calculated at checkout.'
    if (foot) foot.hidden = false
  }

  const fetchCart = async () => {
    try {
      const res = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      if (!res.ok) throw new Error('cart fetch failed')
      render(await res.json())
    } catch (e) {
      /* leave existing markup */
    }
  }

  const changeQuantity = async (line, quantity) => {
    try {
      const res = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      })
      if (!res.ok) throw new Error('change failed')
      render(await res.json())
    } catch (e) {
      fetchCart()
    }
  }

  const showAdded = () => {
    if (!addedNote) return
    addedNote.hidden = false
    if (addedTimer) clearTimeout(addedTimer)
    addedTimer = setTimeout(() => { addedNote.hidden = true }, 2600)
  }

  const open = () => {
    lastFocused = document.activeElement
    drawer.hidden = false
    requestAnimationFrame(() => drawer.classList.add('is-open'))
    drawer.setAttribute('aria-hidden', 'false')
    document.body.classList.add('vk-modal-open')
    if (panel) panel.focus()
  }

  const close = () => {
    drawer.classList.remove('is-open')
    drawer.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('vk-modal-open')
    setTimeout(() => { drawer.hidden = true }, 300)
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus()
  }

  // Open triggers (header cart icon) — progressive enhancement over the /cart link
  document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      open()
      fetchCart()
    })
  })

  // Close triggers + backdrop + ESC
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((el) => el.addEventListener('click', close))
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close()
  })

  // Quantity + remove (event delegation)
  body.addEventListener('click', (event) => {
    const itemEl = event.target.closest('.cart-drawer-item')
    if (!itemEl) return
    const line = parseInt(itemEl.getAttribute('data-line'), 10)
    if (!line) return
    const valueNode = itemEl.querySelector('[data-cart-qty-value]')
    const current = valueNode ? parseInt(valueNode.textContent, 10) || 0 : 0
    if (event.target.closest('[data-cart-remove]')) {
      changeQuantity(line, 0)
    } else if (event.target.closest('[data-cart-qty-inc]')) {
      changeQuantity(line, current + 1)
    } else if (event.target.closest('[data-cart-qty-dec]')) {
      changeQuantity(line, Math.max(current - 1, 0))
    }
  })

  // Intercept add-to-cart forms -> AJAX add -> open drawer with confirmation
  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      const submitButton = form.querySelector('[type="submit"]')
      const originalLabel = submitButton ? submitButton.textContent : ''
      if (submitButton) { submitButton.disabled = true; submitButton.textContent = 'Adding…' }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
        if (!res.ok) throw new Error('add failed')
        await fetchCart()
        open()
        showAdded()
      } catch (e) {
        // Fallback to the standard cart page if AJAX fails
        window.location.href = cartUrl
      } finally {
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = originalLabel || 'Add to cart' }
      }
    })
  })

  // Checkout: preserve the No Returns consent gate
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async () => {
      if (termsCheckbox && !termsCheckbox.checked) {
        if (termsAlert) termsAlert.hidden = false
        termsCheckbox.focus()
        return
      }
      try {
        await fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Terms accepted': 'Yes' } })
        })
      } catch (e) { /* proceed regardless */ }
      window.location.href = '/checkout'
    })
  }

  if (termsCheckbox && termsAlert) {
    termsCheckbox.addEventListener('change', () => {
      if (termsCheckbox.checked) termsAlert.hidden = true
    })
  }

  // Expose a small API so other modules (e.g. Style Finder) can open/refresh the drawer
  window.vkCartDrawer = { open: open, close: close, refresh: fetchCart }
})()

/* ---------------- Size guide modal (global; used on PDP + FAQ/Contact) ---------------- */
;(() => {
  const sizeGuide = document.querySelector('[data-size-guide]')
  if (!sizeGuide) return

  const openGuide = () => {
    if (typeof sizeGuide.showModal === 'function') sizeGuide.showModal()
    else sizeGuide.setAttribute('open', '')
  }
  const closeGuide = () => {
    if (typeof sizeGuide.close === 'function') sizeGuide.close()
    else sizeGuide.removeAttribute('open')
  }

  document.querySelectorAll('[data-size-guide-open]').forEach((btn) => {
    btn.addEventListener('click', openGuide)
  })
  const closeBtn = sizeGuide.querySelector('[data-size-guide-close]')
  if (closeBtn) closeBtn.addEventListener('click', closeGuide)
  sizeGuide.addEventListener('click', (event) => {
    if (event.target === sizeGuide) closeGuide()
  })
})()

/* ---------- New Arrivals de-dupe vs Bestsellers + trim to target count ---------- */
;(() => {
  const target = document.querySelector('[data-dedupe-target]')
  if (!target) return
  const limit = parseInt(target.getAttribute('data-dedupe-limit') || '0', 10)

  // Product ids already shown in the Bestsellers (source) section.
  const seen = new Set()
  document.querySelectorAll('[data-dedupe-source] [data-product-id]').forEach((el) => {
    const id = el.getAttribute('data-product-id')
    if (id) seen.add(id)
  })

  let shown = 0
  target.querySelectorAll('.product-grid-item').forEach((item) => {
    const card = item.querySelector('[data-product-id]')
    if (!card) return // leave non-product items (e.g. the "coming soon" state)
    const id = card.getAttribute('data-product-id')
    if (id && seen.has(id)) {
      item.remove() // already shown in Bestsellers — don't render twice
      return
    }
    if (limit && shown >= limit) {
      item.remove() // trim the render buffer down to the target count
      return
    }
    if (id) seen.add(id)
    shown += 1
  })
})()
